export class BuyerInformationModel {
    Name: string;
    Email: string;
    SBL: string;
    Section: string;
    Block: string;
    Lot: string;
    BuyerID: number;
    IsMailInvitationSent: boolean;
    MailStatus: MailInvitationEnum;
    CommunityLotID:number;
}

export enum MailInvitationEnum {
    YetToBeSent,
    Sent,
    Failed
}


// WEBPACK FOOTER //
// ./src/app/modules/dashboard/buyer-upload-section/Models/BuyerInformationModel.ts